import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

const InvestigativeIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="31.956"
      viewBox="0 0 30.321 31.956"
      y={props.yVal}
      x={props.xVal}
      fill={props.color}
      role="img"
    >
      <title>{t('Investigative Icon')}</title>
      <path
        d="M33.46,29.778l-5.8-5.8a13.726,13.726,0,1,0-2.95,2.491L30.739,32.5a1.9,1.9,0,0,0,2.688,0A1.89,1.89,0,0,0,33.46,29.778ZM7.535,14.833a9.882,9.882,0,1,1,9.9,9.9A9.91,9.91,0,0,1,7.535,14.833Z"
        transform="translate(-3.7 -1.1)"
      />
    </svg>
  );
};

export default InvestigativeIcon;

InvestigativeIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
